<template>
  <div class="report-group-header" :class="{ 'report-group-header--with-stats': hasStats }">
    <div class="report-group-header__label">{{ label }}</div>
    <div v-if="hasStats" class="report-group-header__stats">
      <slot name="stats" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportGroupHeader',
  props: {
    label: { type: String, required: true }
  },
  computed: {
    hasStats() {
      return !!this.$slots.stats;
    }
  }
};
</script>

<style lang="scss" scoped>
.report-group-header {
  align-items: center;
  background: #f1f5f9;
  display: flex;
  justify-content: space-between;
  padding: 10px 14px;
}

.report-group-header__label {
  color: var(--app-text);
  font-size: 15px;
  font-weight: 700;
}

.report-group-header__stats {
  align-items: flex-end;
  display: flex;
  gap: 16px;
}

.report-group-header__stats ::v-deep .stat {
  display: flex;
  flex-direction: column;
  text-align: right;
}

.report-group-header__stats ::v-deep .stat__label {
  color: var(--app-text-muted);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.report-group-header__stats ::v-deep .stat__value {
  color: var(--app-text);
  font-size: 13px;
  font-weight: 700;
}
</style>
